import {
  TWINK_CATEGORY,
  DADDY_CATEGORY,
  SPORTY_CATEGORY,
  BEAR_CATEGORY,
  TRANS_CATEGORY,
} from '@/constants';
import { HisTypeOptionIdType } from '@/pages/Onboarding/options/HisType/types.ts';

export const getCategoryByHisType = (
  hisType: HisTypeOptionIdType,
): string[] => {
  const categoryMap: Record<HisTypeOptionIdType, string[]> = {
    twink: [TWINK_CATEGORY],
    daddy: [DADDY_CATEGORY],
    trans: [TRANS_CATEGORY],
    otter: [BEAR_CATEGORY],
    queer: [TRANS_CATEGORY],
    leather: [SPORTY_CATEGORY],
    boy: [TWINK_CATEGORY],
    pup: [SPORTY_CATEGORY],
    clean_cut: [TWINK_CATEGORY],
    jock_sporty: [SPORTY_CATEGORY],
    bear: [BEAR_CATEGORY],
    geek: [TWINK_CATEGORY],
  };

  return categoryMap[hisType] || [TWINK_CATEGORY];
};
